module.exports = __webpack_public_path__ + "roboto-thin-webfont.f69ae9ed985af4bfa2b6.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-thin-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-thin-webfont.woff
// module chunks = styles